export function toggleClass(elm: HTMLElement, cls: string, state: boolean) {
    // IE har inte stöd för forcead state i classList.toggle.
    if (state) {
        if (!elm.classList.contains(cls)) {
            elm.classList.add(cls);
        }
    } else {
        elm.classList.remove(cls);
    }
}